import { useLocation, useNavigate } from 'react-router-dom'

import { useOrderFormStoreActions } from '@/modules/order/stores/order-form.store'
import { useMainStore } from '@/modules/shared/stores/main.store'
export const useStartOrderByCustomer = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { setIsCustomerStartedOrder, setInitialLocationForOrder } =
    useMainStore().actions
  const { setOperationType: setOperationTypeOrder } = useOrderFormStoreActions()

  const handleStartOrder = () => {
    setInitialLocationForOrder(location.pathname)

    setIsCustomerStartedOrder(true)
    setOperationTypeOrder('add')
    navigate('/pedido/add')
  }

  return {
    action: {
      handleStartOrder,
    },
  }
}
